import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';

export default function ProtectedRoute({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

ProtectedRoute.propTypes = { children: PropTypes.node };